import placeholder from 'assets/img/placeholder.png';
import ReactImageAppear from 'react-image-appear';

export const Img = p => <ReactImageAppear showLoader={false} placeholder={placeholder} {...p} />;
